import { NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NavigationBarItem } from '../../types';
import { GoogleAnalyticsClickBackEventDirective } from '../../directives';
import { Flows, Flow } from '@lx/quote-tool/lite/shared/types';

@Component({
  standalone: true,
  selector: 'lx-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss'],
  imports: [NgForOf, RouterLink, RouterLinkActive, NgTemplateOutlet, NgIf, GoogleAnalyticsClickBackEventDirective],
})
export class NavigationBarComponent {
  items = input<NavigationBarItem[]>([]);
  activeFlow = input<Flow>(Flows.Adult);
}
